import type { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { canAdministerAccount } from '@/api/permissions';
import { useAuth } from '@/contexts/AuthContext';
import { AdminRouteProps as Props } from './AdminRoute.types';

/** The admin area is for account admins only. */
export const AdminRoute: FC<Props> = ({ children }) => {
  const { user } = useAuth();
  if (!canAdministerAccount(user)) {
    return (
      <Navigate
        to='/'
        replace
      />
    );
  }
  return <>{children}</>;
};
